// src/Pages/Shop/Confirm.tsx
import React from "react";
import { Card, Col, Container, Image, Row } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";

import { Shoptopbar } from "Components/ShopTopBar";
import success from "assets/images/success-img.png";
import EmailClothe from "Pages/Catalog/EmailClothe";
import { CommonService } from "Components/CommonService";

const Confirm = () => {
    document.title = "Order Completed | Toner - React FrontEnd";

    const location = useLocation();
    const state = (location.state as any) || {};

    const orderId = state?.order_id ?? null;
    const orderNo = state?.order_no ?? null;
    const paymentStatus = state?.payment_status ?? null;
    const paymentMethod = state?.payment_method ?? null;
    const fulfillmentStatus = state?.fulfillment_status ?? null;

    const title =
        paymentMethod === "cash"
            ? "Your Order Is Placed!"
            : "Your Order Is Completed!";

    const subMessage =
        paymentMethod === "cash"
            ? "Your order has been placed successfully. You can pay at the time of delivery."
            : "You will receive an order confirmation email with details of your order.";

    return (
        <React.Fragment>
            <Shoptopbar title="Order Confirm" page="Confirmation" />

            <section className="section">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={8}>
                            <Card>
                                <Card.Body className="p-4 p-md-5">
                                    <div className="text-center">
                                        <Image src={success} alt="" className="w-50" />
                                    </div>

                                    <div className="text-center mt-5 pt-1">
                                        <h4 className="mb-3 text-capitalize">{title}</h4>

                                        <p className="text-muted mb-2">{subMessage}</p>

                                        {orderNo ? (
                                            <p className="text-muted mb-1">
                                                Order No: <span className="fw-semibold text-dark">{orderNo}</span>
                                            </p>
                                        ) : null}

                                        {orderId ? (
                                            <p className="text-muted mb-1">
                                                Order ID: <span className="fw-semibold text-dark">{orderId}</span>
                                            </p>
                                        ) : null}

                                        {paymentStatus ? (
                                            <p className="text-muted mb-1">
                                                Payment Status: <span className="fw-semibold text-dark text-capitalize">{paymentStatus}</span>
                                            </p>
                                        ) : null}

                                        {paymentMethod ? (
                                            <p className="text-muted mb-1">
                                                Payment Method:{" "}
                                                <span className="fw-semibold text-dark text-capitalize">
                                                    {paymentMethod === "cash"
                                                        ? "Cash on Delivery"
                                                        : paymentMethod}
                                                </span>
                                            </p>
                                        ) : null}

                                        {fulfillmentStatus ? (
                                            <p className="text-muted mb-0">
                                                Fulfillment Status:{" "}
                                                <span className="fw-semibold text-dark text-capitalize">
                                                    {fulfillmentStatus}
                                                </span>
                                            </p>
                                        ) : null}

                                        <div className="mt-4 pt-2 hstack gap-2 justify-content-center">
                                            <Link to="/shop/orderhistory" className="btn btn-primary btn-hover">
                                                View Order <i className="ri-arrow-right-line align-bottom ms-1"></i>
                                            </Link>
                                            <Link to="/dashboard" className="btn btn-soft-danger btn-hover">
                                                Back To Home <i className="ri-home-4-line align-bottom ms-1"></i>
                                            </Link>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>

            <EmailClothe />
            <CommonService />
        </React.Fragment>
    );
};

export default Confirm;